import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/styles';
import { Card } from 'reactstrap';
import RenderFormInput from 'components/forms/RenderFormInput';
import Button from 'components/buttons/Button';
import { requiredValidator, passwordValidator, handleBlur } from 'utils/validators';
import Error from 'components/forms/Error';


const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    backgroundColor: theme.palette.secondary.background,
  },
  card: {
    padding: '1rem',
    width: '450px',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  submitBtn: {
    marginTop: '1rem',
  },
});

const ResetPasswordForm = ({
  classes, handleSubmit, pristine, submitting, error,
}) => (
  <div className={classes.wrapper}>
    <Card className={classes.card}>
      <h2 className={classes.title}>New password</h2>
      <form onSubmit={handleSubmit}>
        <div className="instance-form__body">
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label htmlFor="delayBeforeEmail">New password</label>
          <Field
            name="new_password1"
            component={RenderFormInput}
            type="password"
            onBlur={handleBlur}
            minlength="9"
            maxlength="250"
            validate={[requiredValidator, passwordValidator]}
          />
          <label htmlFor="delayBeforeEmail">Confirm new password</label>
          <Field
            name="new_password2"
            component={RenderFormInput}
            type="password"
            onBlur={handleBlur}
            minlength="9"
            maxlength="250"
            validate={[requiredValidator, passwordValidator]}
          />
          <div><Error error={error} /></div>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            fullWidth
            className={classes.submitBtn}
            disabled={pristine || submitting}
          >
            Reset
          </Button>
        </div>
      </form>
    </Card>
  </div>
);

ResetPasswordForm.propTypes = {
  classes: PropTypes.element.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  error: PropTypes.string,
};

ResetPasswordForm.defaultProps = {
  submitting: false,
  pristine: true,
  error: null,
};

export default compose(
  withStyles(styles),
  reduxForm({
    form: 'reset_password_form',
  }),
)(ResetPasswordForm);
